import { render } from "./DashboardNewContractModel.vue?vue&type=template&id=73d7bb02&scoped=true"
import script from "./DashboardNewContractModel.vue?vue&type=script&lang=js"
export * from "./DashboardNewContractModel.vue?vue&type=script&lang=js"

import "./DashboardNewContractModel.vue?vue&type=style&index=0&id=73d7bb02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d7bb02"]])

export default __exports__